export default __webpack_public_path__ + "static/media/EnterWhoosh.69783c1b.mp3";